import EventJudges from './EventJudges'

export default EventJudges
